import { AnalyticsEvent } from '@guardfinder/analytics';

export class AddressVerifiedEvent extends AnalyticsEvent {
    constructor(isValid: boolean) {
        super('create-job-address-verified', {
            is_address_valid: isValid
        });
    }
}
